import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Checkbox,
} from "@material-ui/core";
import React, { useRef } from "react";
import { useState } from "react";

import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import "./style.css";
import axios from "axios";
import { API } from "../../Constants/APIs";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { addViewpostMetaTag } from "../../Helpers/addViewport";
import { useMediaHook } from "../useMediaHook";
const PasscodeVerfiy = ({ onSubmit, productId }) => {
  const viewportId = `PasscodeVerfiyTag`;

  const isMdOrDown = useMediaHook();

  const url = `${API.postUrls.verifyPasscode}/${productId}`;
  useEffect(() => {
    const remove = addViewpostMetaTag(viewportId);
    return () => {
      remove();
    };
  }, []);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [code, setCode] = useState("");
  const [isInvalidPasscode, setIsInvalidPasscode] = useState(false);
  const verfiyPasscode = (e) => {
    e.preventDefault();
    setIsLoading(true);
    // return;
    axios
      .post(url, { passCode: code })
      .then(({ data }) => {
        if (data.status == "success") onSubmit();
        else {
          setIsInvalidPasscode(true);
          // navigate("/");
        }
      })
      .catch((err) => {
        //    console.log("err ", err);
        // setIsInvalidPasscode(true);
        // navigate("/");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  // getProduct();
  return (
    <div
      style={{
        width: "100%",
        height: "90vh",
        border: "0px solid red",
      }}
    >
      <Dialog
        open={true}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ textAlign: "center", fontSize: "25rem" }}>
          Enter your Passcode
        </DialogTitle>
        <DialogContent>
          <form
            onSubmit={verfiyPasscode}
            style={{
              border: "0px solid red",
            }}
          >
            {" "}
            <PasscodeField
              onChange={(e) => {
                if (setIsInvalidPasscode) setIsInvalidPasscode(false);
                setCode(e.target.value);
              }}
              value={code}
              style={{
                width: isMdOrDown ? "auto" : "300px",
                // width: "300px",
                boxShadow: "inset 2px 1px 4px rgba(0, 0, 0, 0.25)",
              }}
            />
            {isInvalidPasscode ? (
              <div
                style={{
                  textAlign: "center",
                  margin: "1rem 0",
                  color: "red",
                }}
              >
                Invalid Passcode
              </div>
            ) : (
              ""
            )}
            <button
              className="btnCommonStyles"
              type="submit"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                alignSelf: "center",
                width: "max-content",
                padding: "0.8rem 3rem",
                lineHeight: 1,
                borderRadius: "0.6rem",
                margin: "auto",
                marginTop: "0.7rem",
                marginBottom: "1rem",
              }}
            >
              {isLoading ? `Verifying...` : `Submit`}
            </button>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default PasscodeVerfiy;

export const PasscodeField = ({ onChange, className, value, style = {} }) => {
  const [showPassword, setShowPassword] = useState(false);
  const ref = useRef();
  useEffect(() => {
    // ref.current.focus();
  }, []);
  return (
    <div
      style={{
        position: "relative",
        border: "0px solid blue",
        margin: "1rem 0",
      }}
    >
      <input
        ref={ref}
        autoFocus={true}
        className={className ? className : "InputXX"}
        name="title"
        type={showPassword ? "text" : "password"}
        required
        value={value}
        onChange={onChange}
        style={{
          // position: "absolute",
          // top: 0,
          // right: 0,
          // left: 0,
          // bottom: 0,
          marginBottom: "1rem",
          margin: 0,
          ...styleInput,
          ...style,
          border: "0px solid green",
          maxWidth: "100%",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "50%",
          right: 5,
          transform: "translateY(-50%)",
          border: "0px solid aqua",
        }}
      >
        <IconButton
          aria-label="delete"
          size="small"
          onClick={() => {
            setShowPassword((p) => !p);
          }}
        >
          {showPassword ? (
            <VisibilityOffIcon fontSize="inherit" />
          ) : (
            <VisibilityIcon fontSize="inherit" />
          )}
        </IconButton>
      </div>
    </div>
  );
};
const styleInput = {
  width: `96%`,
  height: "37px",
  border: `1px solid #ddd`,
  background: `#ffffff`,
  borderRadius: "5px",
  outline: "none",
  paddingLeft: "10px",
};
